import * as Yup from "yup";
import { validationsLocale } from "./ValidationsLocale";
import { __ } from "@wordpress/i18n";

/**
 * Configure the Yup validation locale for standardized validation messages.
 */
Yup.setLocale(validationsLocale);

/**
 * Centralized validation messages used across the transfer credit simulation form.
 * All messages are localized to Portuguese (Portugal).
 */
const MESSAGES = {
    required: __("Este campo é de preenchimento obrigatório.", "df-simulators"),
    typeError: __(
        "O valor inserido deve ser do tipo correto.",
        "df-simulators"
    ),
    positive: __(
        "O valor inserido deve ser um número positivo.",
        "df-simulators"
    ),
};

/**
 * Validation schema for the transfer credit simulation form.
 * This schema defines the validation rules for all fields in the `loan_savings` form.
 */
export const validations: Record<string, Yup.ObjectSchema<any>> = {
    loan_savings: Yup.object().shape({
        current_loanValue: Yup.number()
            .positive(MESSAGES.positive)
            .required(MESSAGES.required),
        current_rate: Yup.number()
            .positive(MESSAGES.positive)
            .max(100, __("Taxa de juro deve ser no máximo 100", "dfs-simulators"))
            .required(MESSAGES.required),
        current_numberOfTotalInstallments: Yup.number()
            .positive(MESSAGES.positive)
            .required(MESSAGES.required),
        new_loanValue: Yup.number()
            .positive(MESSAGES.positive)
            .required(MESSAGES.required),
        new_rate: Yup.number()
            .positive(MESSAGES.positive)
            .max(100, __("Taxa de juro deve ser no máximo 100", "dfs-simulators"))
            .required(MESSAGES.required),
        new_numberOfTotalInstallments: Yup.number()
            .positive(MESSAGES.positive)
            .required(MESSAGES.required),
    }),
};
